import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fromJS, Map } from 'immutable';
import TabBarItem from 'react/containers/layout/tabs/TabBarItem';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

class TabBar extends Component {

  static propTypes = {
    onClose: PropTypes.func,
    onExpand: PropTypes.func,
    onSelect: PropTypes.func,
    onMove: PropTypes.func,
    scrollTo: PropTypes.func,
    scrolledRef: PropTypes.func,
    tabs: PropTypes.object,
    tags: PropTypes.object,
  }

  onSelectWrapper(tab) {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(tab);
    }
  }

  onCloseWrapper(tab, event) {
    event.preventDefault();
    event.stopPropagation();
    const { onClose } = this.props;
    if (onClose) {
      onClose(tab);
    }
  }

  onExpandWrapper(tab, event) {
    event.preventDefault();
    event.stopPropagation();
    const { onExpand } = this.props;
    if (onExpand) {
      onExpand(tab);
    }
  }

  mapItemToTabBar = (tab) => {
    const { tabs, onMove, tags } = this.props;
    const activeTab = tabs.get('active', Map({}));
    const active = tab.get('key') === activeTab.get('key');
    const customTab = tags[tab.get('tag') || tab.get('key')];
    const customTabName = customTab && customTab.tabName; 
    const onClose = this.onCloseWrapper.bind(this, fromJS(tab));
    const onExpand = this.onExpandWrapper.bind(this, fromJS(tab));
    const extraTabParam = tab.get('extraTabParam', '');
    const title = customTabName ? Monet.I18n.getResourcesByKey(customTabName, extraTabParam) : tab.get('title');
    const onSelectWrapper = this.onSelectWrapper.bind(this, fromJS(tab));
    const key = `tab-bar-${tab.get('key')}`;
    const className = `gmTabs__tab ${(active) ? 'is-active' : ''}`;

    const attributes = {
      liveKey: tab.get('key'),
      closeable: tab.get('closeable'),
      title,
      onSelectWrapper,
      key,
      className,
      active,
      onClose,
      onExpand,
      onMove,
    };

    return (<TabBarItem {...attributes} />);
  }

  scrollTo(direction, event) {
    event.stopPropagation();
    event.preventDefault();
    this.props.scrollTo(direction);
  }

  render() {
    const { tabs, scrolledRef } = this.props;
    const showNav = tabs.get('showNav');
    const items = tabs.get('list').toList().map(this.mapItemToTabBar);
    const style = {
      display: (showNav) ? 'block' : 'none',
    };
    const previous = this.scrollTo.bind(this, 'previous');
    const next = this.scrollTo.bind(this, 'next');
    return (
      <DndProvider backend={ HTML5Backend }>
        <div className="gmTabs__tab-bar reactivo-tabs__tab-bar">
          <div className="previous" style={ style } >
            <a href="/navigation" onClick={ previous }>
              <div className="tabPrevius" />
            </a>
          </div>
          <div className="scrolled" ref={ scrolledRef }>
            { items }
          </div>
          <div className="next" style={ style }>
            <a href="/navigation" onClick={ next }>
              <div className="tabNext" />
            </a>
          </div>
        </div>
      </DndProvider>
    );
  }
}

export default TabBar;
